import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Notification from "../../components/Notification";
import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";
import ConectUs from "../../components/ConectUs";
import { DistanciaNuevosFixed } from "../../components/Pasos";
import FixedNotification from "../../components/FixedNotification";
import EnLineaPagos from "../../components/Enlineapagos";
import Offerenlinea from "../../components/view/OfferEnlinea";

function Enlinea() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <div className="relative">
              <BlockImageCabecera
                src={item.field_portada}
                title={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />
                  </>
                }
              ></BlockImageCabecera>
            </div>
            <div className="relative">
              <Notification
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque1,
                      }}
                    />
                  </>
                }
              ></Notification>
              <DistanciaNuevosFixed></DistanciaNuevosFixed>
            </div>{" "}
            <Breadcumbs
              content={
                <>
                  <NavLink to="/en-linea">En línea</NavLink>
                </>
              }
            ></Breadcumbs>
            <center>
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque2,
                }}
              />
            </center>
            <div className="margin">
              <Offerenlinea></Offerenlinea>
            </div>
            <div className="padding">
              <EnLineaPagos></EnLineaPagos>
            </div> 
            <div className="margin">
              <BlockBackgroundImage
                src={item.field_imagen3}
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque3,
                    }}
                  />
                }
              ></BlockBackgroundImage>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-oferta-linea.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      {/* 
    <FixedNotification
        link="https://utpl.instructure.com/login"
        content={
          <>
            <img src="https://utpl.edu.ec/recursos/img/banner-mel.png"></img>
          </>
        }
      ></FixedNotification> */}
      <ConectUs
        lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes en línea y a distancia."
        instagram="https://www.instagram.com/utplenlinea/"
        facebook="https://www.facebook.com/utplenlinea/"
        tiktok="https://www.tiktok.com/@utplenlinea"
      ></ConectUs>

      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Enlinea;
